import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash } from "@fortawesome/pro-regular-svg-icons";
import { IAccommodationReservationNote } from "pages/secure/facility/accommodation/reservations/types";
import "./reservationNote.scss";

interface IReservationNoteProps {
  note: IAccommodationReservationNote;
  onEdit: (note: IAccommodationReservationNote) => void;
  onDelete: (note: IAccommodationReservationNote) => void;
}

export function ReservationNote({ note, onEdit, onDelete }: IReservationNoteProps) {
  function formatDateMDY(dateStr: string) {
    if (!dateStr) {
      return "";
    }

    const [year, month, day] = dateStr.substring(0, 10).split("-");
    return `${month}/${day}/${year}`;
  }

  return (
    <div className="edit-reservation-note">
      <div className="flex flex-col gap-4">
        <p className="edit-reservation-note_note">{note.content}</p>
        <p className="edit-reservation-note_posted_on">
          Posted on <span className="edit-reservation-note_posted_on_bold">{formatDateMDY(note.created_at)}</span> by{" "}
          <span className="edit-reservation-note_posted_on_bold">{note.user.full_name ?? ""}</span>
        </p>
      </div>

      <div className="flex justify-between items-center mb-2">
        <p className="flex gap-4">
          <div className="edit-reservation-note_action-button edit-reservation-note_action-button_edit">
            <FontAwesomeIcon className="cursor-pointer" icon={faPenToSquare} onClick={() => onEdit(note)} />
          </div>

          <div className="edit-reservation-note_action-button edit-reservation-note_action-button_delete">
            <FontAwesomeIcon className="cursor-pointer" icon={faTrash} onClick={() => onDelete(note)} />
          </div>
        </p>
      </div>
    </div>
  );
}
